<template>
    <v-card
        v-if="controller.model.getStaticFields().length > 0"
        class="pa-4 mb-2"
    >
        <v-row no-gutters>
            <v-col cols="12" class="font-weight-bold mb-4">
                {{ $t("Fields for all clients") }}
            </v-col>
            <v-col class="py-0 d-flex flex-wrap" cols="12">
                <FieldControl
                    v-for="field in controller.model.getStaticFields()"
                    :key="field.name"
                    :field="field"
                    :account-id="controller.model.getCompanyId()"
                    @remove="controller.removeStaticField(field.name)"
                ></FieldControl>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import Controller from "./controller";
import { CUSTOM_FIELD_RELATED_TYPE } from "@/helpers/constants";
import DialogModule from "@/store/modules/dialog";
import CustomFieldEditDialog from "@/components/Dialog/CustomFieldEditDialog/Index";
import FieldControl from "@/views/Import/Xlsx/Settings/FieldControl";

export default {
    name: "ImporterSettingsViewOptions",
    components: {
        CustomFieldEditDialog,
        FieldControl
    },
    props: {
        controller: {
            type: Controller,
            required: true
        }
    },
    setup(props) {
        const { setDialogOptions, openDialog } = DialogModule();

        const addClientGroup = () => {
            setDialogOptions({
                component: () => import("@/views/Dialog/EditClientGroupDialog"),
                payload: { account_id: props.controller.model.getCompanyId() }
            });
            openDialog();
        };

        return {
            CUSTOM_FIELD_RELATED_TYPE,
            addClientGroup
        }
    }
};
</script>
